// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fedex-success-step__message[data-v-f0cb9a80]{display:flex;align-items:center;background:#f0faf0;border-radius:8px;padding:16px}", ""]);
// Exports
module.exports = exports;
